<template>
<svg width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.0387 0.516602H20.9354C22.4287 0.516602 23.642 1.72993 23.642 3.22327V6.20994C23.642 7.3066 22.9654 8.65994 22.2887 9.3366L16.4554 14.4933C15.6387 15.1699 15.102 16.5233 15.102 17.6199V23.4533C15.102 24.2699 14.5654 25.3433 13.8887 25.7633L11.9987 26.9533C10.2254 28.0499 7.7987 26.8133 7.7987 24.6433V17.4566C7.7987 16.4999 7.26203 15.2866 6.70203 14.6099L1.54536 9.17327C0.868698 8.51993 0.332031 7.28327 0.332031 6.4666V3.36327C0.332031 1.72993 1.54536 0.516602 3.0387 0.516602Z" fill="white"/>
</svg>

</template>
<script lang="ts" setup>

</script>
